import React from 'react';
import Location from '../../Assets/Icons/Location';
import { useTranslation } from 'react-i18next';
import storeImg from '../../Assets/Images/store-icon.svg';

export default function StoreCard({ store }) {
  const { t } = useTranslation();
  const { address, description, latitude, longitude, name } = store;
  return (
    <div className="store-card">
      <img src={storeImg} alt="store" loading="lazy" />
      <p className="name">{name}</p>
      <p className="description">{description}</p>
      <a
        href={`https://www.google.com/maps?q=${latitude},${longitude}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <p>
          <Location />
          <span>{address}</span>
        </p>
      </a>
    </div>
  );
}
